import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitPartnershipInquiry(payload) {
  const { data } = await api.post("/partnership-inquiry", payload);
  return data;
}

export async function submitMeetingRequest(payload) {
  const { data } = await api.post("/meeting-request", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

export async function sendChatMessage(session_id, message) {
  const { data } = await api.post("/chat", { session_id, message });
  return data;
}

export function capabilitiesDeckUrl() {
  return `${API}/capabilities-deck`;
}

// Download the capabilities brief as a PDF file. Using a direct anchor
// with the `download` attribute avoids blob: / about:blank navigations
// which some Chrome / Workspace policies flag as "Blocked by Google".
export function openCapabilitiesDeck() {
  const url = capabilitiesDeckUrl();
  const a = document.createElement("a");
  a.href = url;
  a.download = "LogDrive_Capabilities_Brief.pdf";
  a.rel = "noopener noreferrer";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 0);
}
